export default "__VITE_ASSET__C0zsL4RC__"